import { Component, OnInit, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { AngularFireAuth } from "@angular/fire/auth";
import { AngularFireDatabase } from "@angular/fire/database";
import { HttpClient } from "@angular/common/http";
import { Router, RouterModule, ActivatedRoute } from "@angular/router";

import { BsModalService, BsModalRef, ModalDirective } from "ngx-bootstrap/modal";

import { SitedataService } from "../Services/sitedata.service";
import { LinksService } from "../Services/links.service";

import swal from "sweetalert2";

@Component({
  selector: 'app-bookmarks',
  templateUrl: './bookmarks.component.html',
  styleUrls: ['./bookmarks.component.scss']
})
export class BookmarksComponent implements OnInit, OnDestroy {
  // Subscriptions
  authSub;
  capturedLinks = [];
  capturedLinksToBind = [];
  currentBookmarkType = 'all';
  selectedLinkId;
  currentUser;
  notes = [];
  notesToBind = [];
  linkSearchTerm = "";
  isLoading: boolean = false;
  projectName: string;
  selectedLinks = [];
  contentModalRef: BsModalRef;
  @ViewChild('contentModal') contentModal: ModalDirective;

  contentToView;
  fetchingContent:boolean = false;
  constructor(public afAuth: AngularFireAuth,
    public db: AngularFireDatabase,
    public router: Router,
    public http: HttpClient,
    private modalService: BsModalService,
    private siteData: SitedataService,
    private linksService: LinksService) { }

  ngOnInit() {
    this.authSub = this.afAuth.user.subscribe((user) => {
      if (user) {

        // this.isLoading = true;
        this.currentUser = user;
        this.getNotes(user.uid);
      } else {
        this.router.navigate(["/signin"]);
      }
    });
  }

  getNotes(userId) {
    this.notes = [];
    this.db
      .list("/Notes/" + userId + "/active")
      .stateChanges(["child_added"])
      .subscribe((snapshot) => {
        let note = snapshot.payload.val();

        this.notes.push(note);
        
        this.notesToBind = this.notes.reverse();
        this.selectedLinkId = this.notesToBind[0].id;
        this.isLoading = false;
      });
  }

  /**
   * Get the links captured via the browser extension and assigned to current note
   * Add it to Notes linkArray created at the runtime
   * @param userId, noteId
   */
  // async getCapturedLinks(userId) {
  //   this.isLoading = true;
  //   this.capturedLinks = [];
  //   this.capturedLinksToBind = [];
  //   this.db
  //     .list("/captures/" + userId + "/links")
  //     .stateChanges(["child_added"])
  //     .subscribe(
  //       async (snapshot) => {
  //         try {
            
  //           this.capturedLinks.push(<any>snapshot.payload.val());
  //           this.filterLinks();
  //           this.isLoading = false;
  //         } catch (error) {
  //           this.isLoading = false;
  //           console.log(error);
  //         }
  //       },
  //       (error) => {
  //         this.isLoading = false;
  //         console.log(error);
  //       }
  //     );
  // }

  /**
   * Get the user id if authenticated user is found
   */
  checkAuthenticationStatus() {
    return new Promise((resolve, reject) => {
      this.authSub = this.afAuth.user.subscribe((user) => {
        if (user) {
          resolve(user);
        } else {
          reject(false);
        }
      });
    });
  }

  // deleteCapturedLink(link) {
  //   swal
  //     .fire({
  //       title: "Are you sure to delete?",
  //       text: "You won't be able to revert this!",
  //       icon: "warning",
  //       showCancelButton: true,
  //       customClass: {
  //         confirmButton: "btn btn-danger",
  //         cancelButton: "btn btn-secondary",
  //       },
  //       buttonsStyling: false,
  //       // confirmButtonClass: 'btn btn-danger',
  //       confirmButtonText: "Yes, delete it!",
  //       // cancelButtonClass: 'btn btn-secondary'
  //     })
  //     .then(async (result) => {
  //       console.log(result);
  //       if (result.value) {
  //         // Delete the note
  //         let currentUser = await this.checkAuthenticationStatus();
  //         let linkDeleted = await this.deleteLink(currentUser, link);
  //         this.getCapturedLinks((<any>currentUser).uid);
  //         // Show confirmation
  //         swal.fire({
  //           title: "Deleted!",
  //           text: "Your link has been deleted.",
  //           icon: "success",
  //           // buttonsStyling: false,
  //           // confirmButtonClass: 'btn btn-primary'
  //         });
  //       }
  //     });
  // }

  deleteLink(currentUser, link) {
    return new Promise((resolve, reject) => {
      try {
        var linkRef = this.db.database.ref(
          "/captures/" + (<any>currentUser).uid + "/links/" + link.id
        );
        linkRef.set(null);
        resolve(true);
      } catch (e) {
        reject(e);
      }
    })

  }


  linkSelectChanged(link) {
    if (link.checked) {
      this.selectedLinks.push(link);
    } else {
      let tempSelectedLinks = this.selectedLinks;
      for (var i = 0; i < tempSelectedLinks.length; i++) {
        if (tempSelectedLinks[i].id == link.id) {
          this.selectedLinks.splice(i, 1);
        }
      }
    }
    this.getIfSelected();
    // console.log(this.capturedLinks);
  }

  async moveLinks() {
    this.isLoading = true;
    let clearText = "";
    try {
    let currentUser = await this.checkAuthenticationStatus();
    this.selectedLinks.forEach(async (link) => {
      if (link.checked) {
        if (link.type === 'page'|| link.type === 'link' && !link.siteData) {
          (<any>clearText) = await this.linksService.getClearTextData(link.url);
        }
        
        let newLinkRef = this.db.database
          .ref(
            "/Notes/" +
            (<any>currentUser).uid +
            "/active/" +
            this.selectedLinkId +
            "/links"
          )
          .push();
        var newLinkId = newLinkRef.key;
        let notesData = {
          id: newLinkId,
          linkUrl: link.url,
          lastUpdate: Date.now(),
        };

        if (link.type === 'page'|| link.type === 'link') {
          notesData["siteData"] = link.siteData ? link.siteData : clearText;
        }

        newLinkRef.set(notesData);
        this.isLoading = false;
        let linkDeleted = await this.deleteLink(currentUser, link);
      

      }
      
      // Link selection check
    });
    // this.getCapturedLinks((<any>currentUser).uid);
  } catch (error) {
    this.isLoading = false;
    console.log(error);
  }
  }

  // async deleteLinks() {
  //   this.isLoading = true;
  //   let newTempArray = [];
  //   this.capturedLinks.forEach(async (link, index) => {
  //     if (link.checked) {
  //       let currentUser = await this.checkAuthenticationStatus();
  //       this.deleteLink(currentUser, link).then((deleted) => {
  //         // this.getCapturedLinks((<any>currentUser).uid);
  //       });
  //     } else {
  //       newTempArray.push(link);
  //     }
  //   })
  //   this.capturedLinks = newTempArray;
  //   let tempArray = this.performGenericFilter(this.capturedLinks, "title", this.linkSearchTerm);
  //   this.bindCapturedLinks(tempArray);
  //   this.isLoading = false;
  // }

  // showLinksOfType(type, display) {
  //   let tempArray = [];
  //   tempArray = this.capturedLinks.filter((link) => {
  //     if (type === 'link') {
  //       return (link.type === type || link.type === 'page' || link.type === 'undefined' || !link.type);
  //     } else if (type === 'all') {
  //       return true;
  //     } else {
  //       return link.type === type;
  //     }
  //   });
  //   this.currentBookmarkType = display;
  //   // this.capturedLinksToBind = tempArray;
  //   this.bindCapturedLinks(tempArray);
  //   if (type === 'all') {
  //     // this.capturedLinksToBind = this.capturedLinks;
  //     this.bindCapturedLinks(this.capturedLinks);
  //   }
  // }

  // bindCapturedLinks(sourceArray) {
  //   this.capturedLinksToBind = sourceArray;
  //   this.capturedLinksToBind.sort((a, b) => (a.lastUpdate > b.lastUpdate ) ? -1 : 1);
  //   this.isLoading = false;
  // }

  // filterLinks() {
  //   let filteredBookmarksArray = this.performGenericFilter(this.capturedLinks, "title", this.linkSearchTerm);
  //   this.bindCapturedLinks(filteredBookmarksArray);
    
  // }

  performGenericFilter(objectArrayToFilter, field, searchText) {
    
    if (!searchText) {
      searchText = "";
    }
    let tempArray = [];
    tempArray = objectArrayToFilter.filter((obj) => {
      if (!obj[field]) {
        return false;
      }
      return (
        obj[field].toLowerCase().indexOf(searchText.toLowerCase()) > -1
      );
    });
    return tempArray;
  }

  // selectAllLinks() {
  //   this.capturedLinksToBind.forEach((link, index) => {
  //     if (this.capturedLinksToBind[index].checked) {
  //       this.capturedLinksToBind[index].checked = false;
  //     } else {
  //       this.capturedLinksToBind[index].checked = true;
  //       this.getIfSelected();
  //     }

  //   })
  // }

  getIfSelected() {
    let countSelected = 0;
    countSelected = this.selectedLinks.length;
    if (countSelected === 0) {
      return false;
    } else {
      return true;
    }
  }

  createProject() {
    var newNoteRef = this.db.database
      .ref("/Notes/" + this.currentUser.uid + "/active")
      .push();
    var newNoteId = newNoteRef.key;
    let notesData = {
      id: newNoteId,
      title: this.projectName,
      archived: false,
      lastUpdate: Date.now(),
    };

    newNoteRef.set(notesData);
    this.projectName =null;
    this.router.navigate(["/canvas", newNoteId]);
  }

  // async openContentModal(note) {
  //   this.fetchingContent = true;
  //   let clearText = "";
  //   if (note.type === 'page'|| note.type === 'link' && !note.siteData) {
  //     (<any>clearText) = await this.linksService.getClearTextData(note.url);
  //     this.contentToView = (<any>clearText).content;
  //     console.log(this.contentToView);
  //     let currentUser = await this.checkAuthenticationStatus();
  //     this.updateLinkContent(clearText, note, currentUser);
  //     this.contentModal.show();
  //   } else if (note.type === 'image') {
  //     this.contentToView = "<h3>" + note.title + "</h3><img src=" + note.src + " alt='image'/>"
  //     this.contentModal.show();
  //   } else if (note.type === 'selection') {
  //     this.contentToView = "<h3>" + note.title + "</h3><p>" + note.selectionText + "</p>";
  //     this.contentModal.show();
  //   } 
  //   else {
  //     this.contentToView = note.siteData.content;
  //     this.contentModal.show();
  //   }
  //   this.fetchingContent = false;
  //   console.log(clearText);
    
  // }

  // updateLinkContent(content, link, currentUser) {
  //   let linkRef = this.db.database.ref("/captures/" + currentUser.uid + "/links/" + link.id);
  //   linkRef.update({siteData: content});
  // }
  ngOnDestroy() {
    this.authSub = null;
  }

}
